/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".impersonator[_ngcontent-%COMP%]{background:red;padding:5px;font-size:20px;z-index:65000;position:fixed;width:100%;bottom:0}.impersonator[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{float:right}"];
export { styles as styles };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/app.component.scss.shim.ngstyle.js.pre-build-optimizer.js